export default {
  PASSWORD_CHANGE_WARNING_DAYS: 7,
  MAX_INACTIVITY_SECONDS: 15 * 60,
  SECONDS_BEFORE_INACTIVITY_LOGOUT: 2 * 60
}
